export default __webpack_public_path__ + "static/media/rotate.614fa09c.svg";